import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';

const DeleteButton = ({ sx, onClick }) => (
  <Box
    onClick={(event) => {
      event.stopPropagation();
      onClick(event);
    }}
    sx={{
      cursor: 'pointer',
      zIndex: 2,
      position: 'absolute',
      top: '-10px',
      right: '-10px',
      backgroundColor: 'error.main',
      height: 16,
      width: 16,
      padding: '3px',
      borderRadius: '50%',
      display: 'flex',
      ...sx
    }}
  >
    <CloseIcon style={{ height: 10, width: 10, color: 'white' }} />
  </Box>
)

export default DeleteButton;